export default "__VITE_ASSET__CpI0GNH4__"